module.exports = __webpack_public_path__ + "img/sfs_icon.ed144b81.png";